import { createRedesignEntry } from "../redesign-page-entry";

/**
 * Lazy entry for the redesign-v1 documents page — shell is eager; only the page body (list + reused
 * detail sub-routes) is code-split.
 */
export default createRedesignEntry(() => import("./documents-page"), {
  testId: "rd-documents-loading",
  shell: { activeNav: "documents" },
});
